// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // apiUrl : "http://vgr-dev-alb-1650375355.us-east-1.elb.amazonaws.com:8081",
  apiUrl : "https://backend.vgrunning.com",
  angularUrl: "http://localhost:4201",
};




// export const environment = {
//   production: false,
//   apiUrl : "http://localhost:8080",
//   angularUrl: "http://localhost:4200",
// };

// export const environment = {
//   production: false,
//   apiUrl : "http://192.168.0.23:8080",
//   angularUrl: "http://192.168.0.23:4200",
// };



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

